export default "__VITE_ASSET__3fdd0b6b__"